module.exports = __webpack_public_path__ + "static/media/pics5.92abca41.jpg";